import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { SiteList } from '../models/site.model';
import { FeedStockLoadDocumentResponse } from '../interfaces/pricematrixmodel';
import { SiteTanksLookup, SiteTanksResponse } from '../interfaces/regions';

@Injectable({
  providedIn: 'root',
})
export class SiteService {
  baseSiterUrl = environment.baseUrl;
  constructor(private http: HttpClient) {}

  getSiteList(): Observable<SiteList[]> {
    var url = `${this.baseSiterUrl}sites/GetSites`;
    return this.http.get<SiteList[]>(url);
  }
  createSite(formData: any): Observable<any> {
    var url = `${this.baseSiterUrl}sites/SaveSite`;
    return this.http.post<any>(url, formData);
  }
  getHaulerDetailsById(id: any): Observable<any> {
    const url = `${this.baseSiterUrl}haulers/GetSiteById`;
    return this.http.get<any>(`${url}?siteId=${id}`);
  }
  getCitiesByState(id: any): Observable<any> {
    const url = `${this.baseSiterUrl}masters/GetCitiesByStateId`;
    return this.http.get<any>(`${url}?stateId=${id}`);
  }
  getSiteById(id: any): Observable<any> {
    const url = `${this.baseSiterUrl}sites`;
    return this.http.get<any>(`${url}?siteId=${id}`);
  }
  deleteSite(Id: any): Observable<any> {
    const url = `${this.baseSiterUrl}sites/DeleteSite?id=${Id}`;
    return this.http.delete<any>(url);
  }  
  getSiteTanks(id: string):Observable<SiteTanksResponse[]> {
    var url = `${this.baseSiterUrl}sites/GetSiteTanksBySiteId?SiteId=${id}`;
    return this.http.get<SiteTanksResponse[]>(url);
  }
  getSiteTanksLookup(id: number):Observable<SiteTanksLookup[]> {
    var url = `${this.baseSiterUrl}sites/${id}/tankslookup`;
    return this.http.get<SiteTanksLookup[]>(url);
  }
  getSiteDataBySiteTypeMarket(
    selectedMarket: number,
    selectedSiteType: number
  ): Observable<SiteList[]> {
    const url = `${this.baseSiterUrl}sites/GetSites?marketId=${selectedMarket}&siteTypeId=${selectedSiteType}`;
    return this.http.get<SiteList[]>(url);
  }

  getDocuments(
    id: number,
    screenTypeId: number
  ): Observable<FeedStockLoadDocumentResponse[]> {
    var url = `${this.baseSiterUrl}feedstocks/GetDocumentDetails?FS_LoadScheduleId=${id}&ScreenTypeId=${screenTypeId}`;
    return this.http.get<FeedStockLoadDocumentResponse[]>(url);
  }

  deleteDocument(
    fileName: string,
    blobID: string,
    type: number
  ): Observable<boolean> {
    const params = new HttpParams()
      .set('fileName', fileName)
      .set('blobID', blobID)
      .set('Type', type.toString());

    const deleteApiUrl = `${this.baseSiterUrl}feedstocks/DeleteDocument`;

    return this.http.delete<boolean>(deleteApiUrl, { params });
  }
}
